module.exports = __webpack_public_path__ + "img/computer2.d1af702a.png";